import React from 'react';
import PropTypes from 'prop-types';
import * as Cookie from "js-cookie";
import {injectIntl} from 'react-intl';

import './CategoryPage.sass';

import {connect} from 'react-redux';

import {fetchTaxonBySlug, fetchTaxonChildrenBySlug} from '../../ducks/taxons';
import {findMenuTaxon, taxonNestedSet} from '../../utils/taxons';
import {setAlternateResources} from '../../ducks/channels';
import {setBackground, setMainTaxonDropdownVisibility} from '../../ducks/ui';
import {analyticsViewProductOrCategory} from '../../middlewares/analytics/actions';

import syncLocation from '../syncLocation/syncLocation';

import {closestBackgroundImage} from '../../components/background/Background';

import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import CategoryMenu from '../../components/categoryMenu/CategoryMenu';
import Menu from '../../components/menu/Menu';
import ErrorPage from '../errorPage/ErrorPage';
import Loader from '../../components/loader/Loader';
import Meta from '../../components/meta/Meta';
import JSONLDBreadcrumbs from '../../components/JSON-LD/JSONLDBreadcrumbs';
import JSONLDBoosthive from '../../components/JSON-LD/JSONLDBoosthive';
import CategoryProductList from './categoryProductList/CategoryProductList';
import CategoryEventList from './categoryEventList/CategoryEventList';
import WhyUsSection from '../../components/whyUsSection/WhyUsSection';
import Tabs from '../../components/tabs/Tabs';
import WysiwygHtml from '../../components/rawHtml/WysiwygHtml';
import FeaturedEvents from '../../components/featuredEvents/FeaturedEvents';
import ChannelLink from '../channelUtils/ChannelLink';

const canonicalMap = {
  'w/gold': '/service/wow-gold',
  'wow-mop/gold': '/service/wow-mop-gold',
};

const metaMap = {
  // 'apex-legends': [{"name": "googlebot", "content": "noindex"}],

  // name: robots
  //'legacy-content': [{"name": "robots", "content": "noindex"}],

  'poe-2/bundles': [{"name": "robots", "content": "noindex"}],

  'wow/gold': [{"name": "robots", "content": "noindex"}],
  'wow-classic/gold': [{"name": "robots", "content": "noindex"}],
  'wow-anniversary/gold': [{"name": "robots", "content": "noindex"}],
  'wow/raids/season-1': [{"name": "robots", "content": "noindex"}],
};

const categoryByDisplayMode = {
  'default': CategoryProductList,
  'calendar': CategoryEventList
};

const getCategoryComponentByDisplayMode = (taxon) => {
  return categoryByDisplayMode[taxon.displayMode] || categoryByDisplayMode['default'];
};

const getSubcategoryTaxon = (taxon) => {
  if (taxon.level === 2) {
    return taxon;
  }

  return taxon.parents.find(it => it.level === 2);
};

@connect(({taxons, channels}, {params}) => ({
  taxon: taxons.taxon[params.splat],
  filterTaxons: (taxons.taxon[params.splat] && getSubcategoryTaxon(taxons.taxon[params.splat])) && taxons.children[getSubcategoryTaxon(taxons.taxon[params.splat]).slug],
  menu: taxons.taxon[params.splat] && taxons.children[findMenuTaxon(taxons.taxon[params.splat]).slug],
  activeChannel: channels.activeChannel,
}))
@injectIntl
@syncLocation(({taxon}) => taxon && findMenuTaxon(taxon).slug)
export default class CategoryPage extends React.PureComponent {
  static fetchData = ({dispatch, params, cookies}) => dispatch(fetchTaxonBySlug(params.splat, cookies))
    .then(taxon => Promise.all([
      dispatch(fetchTaxonChildrenBySlug(findMenuTaxon(taxon).slug)),
      getCategoryComponentByDisplayMode(taxon) && getCategoryComponentByDisplayMode(taxon).fetchData({dispatch, taxon}),
      getSubcategoryTaxon(taxon) && dispatch(fetchTaxonChildrenBySlug(getSubcategoryTaxon(taxon).slug, taxon.level + 1)),
      dispatch(setAlternateResources(taxon.alternateSlugs, ''))
    ]));

  componentDidMount() {
    const {dispatch, params, taxon, filterTaxons, menu} = this.props;

    if (taxon === undefined) {
      dispatch(fetchTaxonBySlug(params.splat));
    }

    if (taxon && menu === undefined) {
      dispatch(fetchTaxonChildrenBySlug(findMenuTaxon(taxon).slug))
    }

    if (taxon && getSubcategoryTaxon(taxon) && filterTaxons === undefined) {
      dispatch(fetchTaxonChildrenBySlug(getSubcategoryTaxon(taxon).slug, taxon.level + 1));
    }

    if (taxon) {
      const image = closestBackgroundImage(taxon, ...taxon.parents.slice().reverse());

      dispatch(setBackground(image));
      dispatch(setAlternateResources(taxon.alternateSlugs, ''));
      dispatch(setMainTaxonDropdownVisibility(true));
      dispatch(analyticsViewProductOrCategory(taxon));
    }
  }

  componentDidUpdate(prevProps) {
    const {dispatch, params, taxon, filterTaxons, menu} = this.props;

    if (taxon === undefined) {
      dispatch(fetchTaxonBySlug(params.splat));
    }

    if (taxon && menu === undefined) {
      dispatch(fetchTaxonChildrenBySlug(findMenuTaxon(taxon).slug));
    }

    if (taxon && getSubcategoryTaxon(taxon) && filterTaxons === undefined) {
      dispatch(fetchTaxonChildrenBySlug(getSubcategoryTaxon(taxon).slug, taxon.level + 1));
    }

    if (taxon) {
      const image = closestBackgroundImage(taxon, ...taxon.parents.slice().reverse());

      dispatch(setBackground(image));
      dispatch(setAlternateResources(taxon.alternateSlugs, ''));
      dispatch(setMainTaxonDropdownVisibility(true));
    }

    if (taxon && prevProps.taxon !== taxon) {
      dispatch(analyticsViewProductOrCategory(taxon));
    }
  }

  componentWillUnmount() {
    const {dispatch} = this.props;

    dispatch(setMainTaxonDropdownVisibility(false));
  }

  render() {
    const {intl, taxon, filterTaxons, menu, activeChannel} = this.props;

    const mainTaxonParentSlugs = taxon && taxon.parents.map(taxon => taxon.slug);

    if (Cookie.get('blacklist')) {
      const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

      if (mainTaxonParentSlugs && mainTaxonParentSlugs.some(taxon => excludedTaxons.includes(taxon))) {
        return <ErrorPage />;
      }
    }

    if (taxon === false) {
      return <ErrorPage/>;
    }

    if (!taxon || !menu) {
      return <Loader page/>;
    }

    const filterTaxonsList = filterTaxons && [{name: 'All', slug: getSubcategoryTaxon(taxon).slug}, ...filterTaxons].map(it => ({name: it.name, value: it.slug}));
    const breadcrumbs = taxon.parents.filter(it => it.level >= 1).concat(taxon);
    const menuTree = (menu && !!menu.length) && taxonNestedSet.nest(menu);
    const taxonMeta = taxon.metatag || {};
    const featuredEvents = taxon.featuredEvents || [];

    const slug = taxon.slug;
    const regex = /^guides\/.*$/;
    const isGuides = slug.match(regex);

    const uniqueProducts = new Set();
    featuredEvents.map((event) => {
      uniqueProducts.add(event.productVariant.id);
    });

    let groupedEvents = [];
    for (let productId of uniqueProducts) {
      const filteredEvent = featuredEvents.filter((event) => {
        return event.active && event.productVariant.id === productId;
      });

      if (filteredEvent.length) {
        groupedEvents.push(filteredEvent);
      }
    }

    const CategoryComponent = getCategoryComponentByDisplayMode(taxon);

    return (
      <div>
        <Meta
          title={taxonMeta.pageTitle}
          fallbackTitle={taxon.name}
          description={taxonMeta.description}
          keywords={taxonMeta.keywords}
          image={!!taxon.images.length && taxon.images[0].path}
          canonical={Object.keys(canonicalMap).includes(taxon.slug) ? canonicalMap[taxon.slug] : undefined}
          alternateSlug={taxon.alternateSlugs && taxon.alternateSlugs.default && taxon.alternateSlugs.default.slug}
          meta={Object.keys(metaMap).includes(taxon.slug) ? metaMap[taxon.slug] : undefined}
        />

        <JSONLDBreadcrumbs
          links={[
            {
              name: intl.formatMessage({ id: "section.breadcrumbs.home" }),
              to: ChannelLink.formatLink(activeChannel, "/"),
            },
            ...breadcrumbs.map((it, index) => ({
              name: it.name,
              ...(index !== breadcrumbs.length - 1 && {
                to: ChannelLink.formatLink(activeChannel, it.slug),
              }),
            }))
          ]}
        />

        <JSONLDBoosthive />

        <div className="container">
          <div className="row">
            <Menu items={menuTree || []} breadcrumbs={breadcrumbs}/>

            <div className="page-category">
              <Breadcrumbs links={breadcrumbs.map((it, idx) => ({
                name: it.name,
                to: idx !== breadcrumbs.length - 1 ? `/${it.slug}` : undefined
              }))}/>

              {menuTree && <CategoryMenu title="Menu" items={menuTree} breadcrumbs={breadcrumbs}/>}

              <h1>{taxonMeta.headTitle || taxon.name}</h1>

              {filterTaxonsList && filterTaxonsList.length > 1 && !isGuides && (
                <div className="page-category__filters">
                  <Tabs
                    items={filterTaxonsList}
                    active={taxon.slug}
                    asLinks
                  />
                </div>
              )}

              {!!taxon.description && (
                <WysiwygHtml
                  className="page-category__description"
                  content={taxon.description}
                />
              )}

              {!!groupedEvents.length && (
                <FeaturedEvents taxon={taxon} events={groupedEvents} />
              )}

              {!!CategoryComponent && (
                <CategoryComponent taxon={taxon}/>
              )}

              {!!taxon.seoText && (
                <WysiwygHtml
                  className="page-category__seo"
                  content={taxon.seoText}
                />
              )}
            </div>
          </div>
        </div>

        <WhyUsSection/>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/categoryPage/CategoryPage.js